import React, { Component } from 'react';
import { EditorState, ContentState, convertToRaw, Modifier, Entity, RichUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import SelectField from '../../../components/inputs/selectField';
import ColorPic from '../../../components/inputs/colorToolbar';

class CustomFieldMap extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedField: null
		};
	}

	addField = (customField) => {
		const { editorState, onChange } = this.props;
		editorState.getCurrentContent().createEntity('MENTION', 'IMMUTABLE', { value: customField.value });
		const contentState = Modifier.replaceText(
			editorState.getCurrentContent(),
			editorState.getSelection(),
			customField.value,
			editorState.getCurrentInlineStyle(),
			editorState.getCurrentContent().getLastCreatedEntityKey()
		);
		onChange(EditorState.push(editorState, contentState, 'insert-characters'));
	};

	render() {
		const { customFields } = this.props;
		return (
			<SelectField
				placeholder="Custom Fields"
				value={this.state.selectedField}
				relative={true}
				options={customFields}
				style={{ width: 200, marginBottom: 5 }}
				onChange={(e) => this.addField(e)}
			/>
		);
	}
}

export default class RichTextEditor extends Component {
	constructor(props) {
		super(props);

		const blocksFromHtml = htmlToDraft(props.value && props.value !== '' ? props.value : props.defaultElement ? props.defaultElement : '');
		const { contentBlocks, entityMap } = blocksFromHtml;
		this.state = {
			editorState: EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap)),
			focused: false,
			codeViewEnabled: false,
			textareaheight: 1,
			original: props.value || ''
		};

		document.addEventListener('mousedown', this.handleClickOutside);
		//console.log(props);
	}

	componentDidUpdate(prevProps) {
		// Check if the value prop has changed
		if (prevProps.value !== this.props.value && this.state.original !== this.props.value) {
		  // Don't update if the editor is currently focused (user is typing)
		  if (!this.state.focused) {
			// Convert the new HTML content to Draft.js format
			const blocksFromHtml = htmlToDraft(this.props.value || this.props.defaultElement || '');
			const { contentBlocks, entityMap } = blocksFromHtml;
			
			// Update the editor state with the new content
			const newEditorState = EditorState.createWithContent(
			  ContentState.createFromBlockArray(contentBlocks, entityMap)
			);
			
			// Update state with the new editor state and track the new original value
			this.setState({
			  editorState: newEditorState,
			  original: this.props.value || ''
			});
		  } else {
			// Just store the new original value without updating the editor state
			// This way we won't reset it while user is typing
			this.setState({
			  original: this.props.value || ''
			});
		  }
		}
	  }

	onEditorStateChange = (editorState) => {
		let text = '';
		convertToRaw(editorState.getCurrentContent()).blocks.forEach((b) => (text += b.text + '\n'));
		const html = draftToHtml(convertToRaw(editorState.getCurrentContent()), null, null, (entity, text) => {
			if (entity.type === 'MENTION') {
				const wrapper = text.replace(
					entity.data.value,
					`<a className="wysiwyg-mention" data-mention data-value="${entity.data.value}">${entity.data.value}</a>`
				);
				return wrapper;
			}
		});
		let processedHtml = text && text.trim() != '' ? html.replace(/<p/g, '<div').replace(/<\/p>/g, '</div>') : '';
		this.props.onChange(processedHtml);
		this.setState({
			editorState
			//bodyText: text,
			//bodyHtml: draftToHtml(convertToRaw(editorState.getCurrentContent()))
		});
	};

	handleClickOutside = (event) => {
		if (this.props.id) {
			try {
				const escapedId = CSS.escape(this.props.id);
				if (!event.target.closest(`#${escapedId}`)) {
					this.setState({ focused: false });
				}
			} catch (error) {
				console.warn("Click outside detection failed:", error);
			}
		}
	};

	handleChange = (event) => {
		const { textareaheight } = this.state;
		const height = event.target.scrollHeight;
		const rowHeight = 20;
		const trows = Math.ceil(height / rowHeight) - 1;
		if (trows !== textareaheight) {
			this.setState({ textareaheight: trows });
		}
		this.props.onChange(event.target.value);
	};

	toggleCodeView = () => {
		if (this.state.codeViewEnabled) {
			const blocksFromHtml = htmlToDraft(this.props.value ? this.props.value : this.props.defaultElement ? this.props.defaultElement : '');
			const { contentBlocks, entityMap } = blocksFromHtml;
			this.setState({
				codeViewEnabled: false,
				editorState: EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap))
			});
		} else {
			this.setState({ codeViewEnabled: true });
		}
	};

	render() {
		const { editorState, codeViewEnabled, textareaheight } = this.state;
		const { id, label,required,placeholder, className, options, blockTypeOptions } = this.props;
		//return <div />;
		const additonalOptions = options || [];
		return (
			<div
				key={id}
				className="posRel mb-25 w-100"
				id={id}>

				<div className="labelContainer">
					<div className="formFieldLabel">{label}{required ? '*' : ''}</div>
				</div>
				{!codeViewEnabled ? (
					<Editor
						key={`editor-${id}`}
						id={`editor-${id}`}
						toolbarCustomButtons={[<CustomFieldMap customFields={this.props.customFields} />]}
						placeholder={this.props.placeholder}
						toolbar={{
							options: ['inline', 'fontSize', 'fontFamily', 'colorPicker', 'link', ...additonalOptions],
							inline: {
								options: ['bold', 'italic']
							},
							blockType: {
								inDropdown: false,
								options: blockTypeOptions ? blockTypeOptions : undefined,
								className: undefined,
								component: undefined,
								dropdownClassName: undefined
							},
							fontSize: {
								options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96]
							},
							fontFamily: {
								options: this.props.fontFamilies
							},
							colorPicker: { component: ColorPic }
						}}
						mention={true}
						toolbarHidden={!this.state.focused}
						editorState={editorState}
						wrapperClassName="parameter-wrapper"
						editorClassName="rich-editor"
						onEditorStateChange={this.onEditorStateChange}
						handleReturn={(e, editorState) => {
							if (e.key === 'Enter') {
								this.onEditorStateChange(RichUtils.insertSoftNewline(editorState));
								return 'handled';
							}
							return 'not-handled';
						}}
						onFocus={() => {
							this.setState({ focused: true });
						}}
						onBlur={() => {
							//this.setState({ focused: false });
						}}
					/>
				) : (
					<DynamicTextarea
						className="formFieldTextArea"
						value={this.props.value}
						rows={textareaheight}
						onChange={this.handleChange}
						updateRowHeight={(rh) => this.setState({ textareaheight: rh })}
					/>
				)}
				<div className="codeToggleIcon" onClick={this.toggleCodeView}>
					{codeViewEnabled ? <i className="las la-paragraph" /> : <i className="las la-code" />}
				</div>
			</div>
		);
	}
}

class DynamicTextarea extends Component {
	constructor(props) {
		super(props);
		this.ta = React.createRef();
	}

	componentDidMount() {
		const height = this.ta.current.scrollHeight;
		const rowHeight = 20;
		const trows = Math.ceil(height / rowHeight) - 1;
		this.props.updateRowHeight(trows);
	}

	render() {
		return (
			<div className="formFieldInputContainer">
				<textarea
					ref={this.ta}
					className="formFieldTextArea"
					value={this.props.value}
					rows={this.props.rows}
					onChange={this.props.onChange}
				/>
			</div>
		);
	}
}
